// @flow
import React from 'react';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Configurator from './components/Configurator';
import { colors, fonts } from './assets/scripts/constants';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: colors.orange,
      main: colors.orange,
      dark: colors.orange,
      contrastText: colors.orange,
    },
    secondary: {
      main: colors.black,
    },
  },
  typography: {
    fontFamily: fonts.primary,
    fontSize: '16',
  },
});

/**
 * External app wrapper, add HOCs etc here.
 *
 * @returns {object} App component
 */
function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <Configurator />
    </MuiThemeProvider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js